var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgPlus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0832 6.70842V7.29175C11.0832 7.45283 10.9526 7.58342 10.7915 7.58342H7.58317V10.7917C7.58317 10.9528 7.45259 11.0834 7.2915 11.0834H6.70817C6.54709 11.0834 6.4165 10.9528 6.4165 10.7917V7.58342H3.20817C3.04709 7.58342 2.9165 7.45283 2.9165 7.29175V6.70842C2.9165 6.54733 3.04709 6.41675 3.20817 6.41675H6.4165V3.20841C6.4165 3.04733 6.54709 2.91675 6.70817 2.91675H7.2915C7.45259 2.91675 7.58317 3.04733 7.58317 3.20841V6.41675H10.7915C10.9526 6.41675 11.0832 6.54733 11.0832 6.70842Z",
    fill: "currentColor"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlus);
export default __webpack_public_path__ + "static/media/plus.83a608a68ef0b8d7d8f4ee07a0e51ab0.svg";
export { ForwardRef as ReactComponent };